import { render, staticRenderFns } from "./EditPageModal.vue?vue&type=template&id=6a3c70e3"
import script from "./EditPageModal.vue?vue&type=script&lang=ts"
export * from "./EditPageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports